import { render, staticRenderFns } from "./TemplateItemFormulaModal.vue?vue&type=template&id=a564cfb6&scoped=true"
import script from "./TemplateItemFormulaModal.vue?vue&type=script&lang=js"
export * from "./TemplateItemFormulaModal.vue?vue&type=script&lang=js"
import style0 from "./TemplateItemFormulaModal.vue?vue&type=style&index=0&id=a564cfb6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a564cfb6",
  null
  
)

export default component.exports